<template>
  <div class="inter-wrapper">
    <HeaderInter
      v-if="detail"
      :back-path="'/product/cate/' + detail.category_id"
    />

    <div v-if="detail" class="product-kv">
      <ProductSilder :banners="images" />
      <div class="product-content">
        <h2 class="name">
          <span>{{ detail.name }}</span>
        </h2>

        <div class="theme">
          <div class="theme-group">
            <p class="theme-name">
              {{ cateName }}
            </p>
            <p class="country">
              {{ countryName }} <span v-if="countryName && areaName">·</span>
            </p>
            <p class="city">
              {{ areaName }}
            </p>
          </div>
          <p v-if="detail.min_price === -1" class="price">
            <big>{{ $langt('全點支付') }}</big>
            <!-- 最低價 NT$<big>{{ detail.min_price | priceFormat }}</big> -->
          </p>
          <p v-else class="price">
            {{ $langt('最低價') }}
          
            <span v-if="detail.min_price > 0">
              {{ detail.currency_code | currencyTitle }}<big>{{ detail.min_price | priceFormat(detail.currency_code) }} </big>
              <span v-if="detail.currency" class="price-sub">
                ({{ detail.currency.code | currencyTitle }}{{ detail.currency.min_price | priceFormat(detail.currency.code) }})
              </span>
            </span>
            <span v-if="detail.min_price > 0 && detail.point > 0"> + </span>
            <span
              v-if="detail.point > 0"
            ><big> {{ detail.point }}{{ $langt('點') }}</big></span>
          </p>
        </div>
        <p v-if="detail.saleoff" class="saleoff">
          {{ detail.saleoff? detail.saleoff : '' }}
        </p>
      </div>
    </div>
    <div v-if="detail" class="producTab-content">
      <div class="inter-wrapper">
        <div class="container">
          <div class="sidebar">
            <fixed-header :threshold="160">
              <ul
                v-scroll-spy-active="{ class: 'customActive' }"
                v-scroll-spy-link
                class="menu"
              >
                <li
                  v-for="(item, index) in titles"
                  :key="index"
                  class="menu-item"
                >
                  <a>{{ item }}</a>
                </li>
              </ul>
            </fixed-header>
          </div>
          <div
            v-scroll-spy="{
              offset: 80,
              time: 5,
              steps: 30,
              sectionSelector: '.item'
            }"
            class="main"
          >
            <!-- 方案 -->
            <div class="menu-list py-3 item">
              <ol>
                <li
                  v-for="(item, index) in viewdetail.plans"
                  :key="index"
                  :class="planClass(item, index)"
                  @click="changePlan(index)"
                >
                  <p class="name">
                    <span>
                      {{ getPlanPriceName(item) }}
                    </span>
                    <span v-if="item.refund_type === 2" class="refundtext">
                      <!-- {{ item.policy_cancel }} -->
                      {{ $langt('不可取消') }}
                    </span>
                  </p>
                  <p v-if="planHasStock(item)" class="price">
                    <span
                      v-if="
                        planHasStock(item) &&
                          !item.prices[0].points.length &&
                          item.prices[0].origin_price <=
                          item.prices[0].sale_price
                      "
                      class="price-2"
                    >
                      {{ $langt('優惠價') }}
                    </span>
                    <span v-else-if="planHasStock(item)" class="originprice">
                      {{ $langt('原價') }}{{ detail.currency_code | currencyTitle }}{{ item.prices[0].origin_price | priceFormat(detail.currency_code) }}
                      <span v-if="item.prices[0].currency" class="originprice-sub">
                        ({{ item.prices[0].currency.code | currencyTitle }}{{ item.prices[0].currency.origin_price | priceFormat(item.prices[0].currency.code) }})
                      </span>
                    </span>
                    <span v-if="item.prices[0].points.length > 0">
                      {{ item.prices[0].points[0].point }}點
                      <span
                        v-if="item.prices[0].points[0].sale_price > 0"
                      >+ {{ detail.currency_code | currencyTitle }}
                        {{ item.prices[0].points[0].sale_price | priceFormat(detail.currency_code) }}
                      </span>
                    </span>
                    <span v-else-if="item.prices[0].sale_price > 0">
                      {{ detail.currency_code | currencyTitle }}{{ item.prices[0].sale_price | priceFormat(detail.currency_code) }}
                      <span v-if="item.prices[0].currency" class="saleprice-sub">
                        ({{ item.prices[0].currency.code | currencyTitle }}{{ item.prices[0].currency.sale_price | priceFormat(item.prices[0].currency.code) }})
                      </span>
                    </span>
                    <span v-else-if="item.prices[0].sale_price === 0">
                      {{ $langt('免費') }}
                    </span>
                    <em v-if="!planHasStock(item)">{{ $langt('完售') }}</em>
                  </p>
                  <p v-else class="price">
                    <span> {{ $langt('原價') }}{{ detail.currency_code | currencyTitle }}{{ item.prices[0].origin_price | priceFormat(detail.currency_code) }}
                      <span v-if="item.prices[0].currency" class="originprice-sub">
                        ({{ item.prices[0].currency.code | currencyTitle }}{{ item.prices[0].currency.origin_price | priceFormat(item.prices[0].currency.code) }})
                      </span>
                    </span>
                    <em>{{ $langt('完售') }}</em>
                  </p>
                </li>
              </ol>
            </div>

            <!-- AD-banner -->
            <div
              v-if="$store.getters.banner && getRandomBanner()"
              class="promote-box"
            >
              <a :href="getRandomBanner().link">
                <img :src="getRandomBanner().img" alt="" class="w-100 img-fluid">
              </a>
            </div>

            <!-- 商品特色 -->
            <div class="py-4 item">
              <dl v-if="viewdetail.highlight && viewdetail.highlight.some(item => item.trim() !== '')">
                <dt>{{ $langt('商品特色') }}</dt>
                <dd v-for="(item, index) in viewdetail.highlight" :key="index">
                  {{ item }}
                </dd>
              </dl>
            </div>

            <div class="py-3 item">
              <dl v-if="planDesc">
                <dt>{{ $langt('方案說明') }}</dt>
                <dd class="nl2br">{{ planDesc }}</dd>
              </dl>
              <dl v-if="planExpire">
                <dt>{{ $langt('方案使用期限') }}</dt>
                <dd>{{ planExpire }}</dd>
              </dl>

              <dl v-if="priceInclude">
                <dt>{{ $langt('費用包含') }}</dt>
                <dd>{{ priceInclude }}</dd>
              </dl>

              <dl v-if="priceExclude">
                <dt>{{ $langt('費用不包含') }}</dt>
                <dd>{{ priceExclude }}</dd>
              </dl>
              <dl v-if="detail.introduction">
                <dt>{{ $langt('圖文詳情') }}</dt>
                <dd class="nl2br" v-text="detail.introduction" />
              </dl>
              <dl v-if="useGuide">
                <dt>{{ $langt('使用方法') }}</dt>
                <dd class="nl2br" v-text="useGuide" />
              </dl>
              <dl v-if="notice">
                <dt>{{ $langt('票券使用注意事項') }}</dt>
                <dd class="nl2br" v-text="notice" />
              </dl>
              <dl v-if="gettrusttext(viewdetail)">
                <dt>{{ $langt('信託/價金文字') }}</dt>
                <dd class="nl2br" v-text="gettrusttext(viewdetail)" />
              </dl>
              <dl v-if="viewdetail.issue_info">
                <dt>{{ $langt('發行資訊') }}</dt>
                <dd class="nl2br" v-text="viewdetail.issue_info" />
              </dl>
              <dl v-if="viewdetail.plans.length &&
                (viewdetail.plans[selectedPlan].refund_type === 2 || viewdetail.plans[selectedPlan].policy_cancel)"
              >
                <dt>{{ $langt('取消政策') }}</dt>
                <dd class="nl2br">{{ viewdetail.plans[selectedPlan].policy_cancel || $langt('不可取消') }}</dd>
              </dl>
            </div>

            <!-- 我是分店 -->
            <div
              v-if="viewdetail.plans[selectedPlan].branches.length"
              class="py-3 item"
            >
              <dl>
                <dt>{{ $langt('店家資訊') }}</dt>
                <dd
                  v-for="(item, index) in viewdetail.plans[selectedPlan]
                    .branches"
                  :key="index"
                >
                  ● {{ item.branch_name }} : {{ item.branch_address }}
                  {{ item.branch_phone }}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PaymentBtn -->
    <div v-if="detail" class="payment-rule">
      <div v-if="detail.has_stock" class="btn-group">
        <button
          class="btn btn-credit"
          type="button"
          :style="!hasPoint ? 'flex: auto' : ''"
          @click="open('all')"
        >
          {{ $langt('付款') }}
        </button>

        <button
          v-if="hasPoint"
          class="btn btn-point"
          type="button"
          @click="open('all')"
        >
          {{ cashPointPay }}
        </button>
      </div>
      <div v-else class="btn-group">
        <button
          class="btn btn-credit no-stock"
          type="button"
          :style="!hasPoint ? 'flex: auto' : ''"
          disabled
        >
          {{ $langt('已售完') }}
        </button>
      </div>
      <BottomSheet
        ref="all"
        :max-width="maxWidth"
        :max-height="maxHeight"
        :overlay="overlay"
        :click-to-close="clickToClose"
        :rounded="rounded"
        :effect="effect"
        :background-scrollable="false"
      >
        <template #title>
          <div class="sheet-content all" style="padding:8px;">
            <div class="title" style="position:relative;">
              <span>{{ $langt('方案及數量') }}</span>
              <div
                style="position: absolute;right: 5px;top: 0px;cursor: pointer;"
                @click="close('all')"
              >
                &#215;
              </div>
            </div>
          </div>
        </template>
        <template #content>
          <div class="sheet-content all point">
            <div class="prod-group">
              <div class="prod-group-title">
                <span>{{ $langt('請選擇方案種類') }}</span>
              </div>
              <div v-for="(plan, planIndex) in detail.plans" :key="planIndex">
                <div
                  v-for="(price, pricesIndex) in plan.prices"
                  v-show="price.stock > 0"
                  :key="pricesIndex"
                  >
                  <div
                    ref="proditems"
                    :class="[
                      'prod-items',
                      {
                        active:
                          price.price_id ===
                          selectedPrice('price', plan, price, null)
                            .price_id &&
                          !selectedPrice('price', plan, price, null).point
                      }
                    ]"
                    @click="setItem(plan, price)"
                  >
                    <span>{{ plan.plan_name }}</span>
                    <div>
                    <em>
                      {{ price.price_name }}
                      <br>
                      <!-- currencyTitle:幣別 point.sale_price=價錢 priceFormat:保留最多10位數-->
                      <small>{{ detail.currency_code | currencyTitle }}{{ price.sale_price | priceFormat(detail.currency_code) }}
                        <small v-if="detail.currency">
                          ({{ price.currency.code | currencyTitle }}{{ price.currency.sale_price | priceFormat(price.currency.code) }})
                        </small>
                      </small>
                      <span id="startingPrice" style="font-size:22px;margin-left:5px;" v-if="viewdetail.need_booking">{{ $langt('起') }}</span>
                    </em>
                    </div>
                  </div>
                  <div
                    v-for="(point, pointIndex) in price.points"
                    ref="proditems"
                    :key="pointIndex"
                    :class="[
                      'prod-items',
                      {
                        active:
                          point.point_id ===
                          selectedPrice('point', plan, price, point)
                            .point_id &&
                          selectedPrice('point', plan, price, null).point
                      }
                    ]"
                    @click="setItem(plan, price, point)"
                  >
                    <span>{{ plan.plan_name }}</span>
                    <em>
                      {{ price.price_name }}
                      <br>
                      <small>
                        <span class="point">{{ point.point }}</span>{{ $langt('點') }}＋{{ detail.currency_code | currencyTitle }}{{ point.sale_price | priceFormat(detail.currency_code) }}
                        <small v-if="detail.currency">
                          <span class="point">{{ point.point }}</span>{{ $langt('點') }}＋{{ price.currency.code | currencyTitle }}{{ point.currency.sale_price | priceFormat(price.currency.code) }}
                        </small>
                      </small>
                      
                    </em>
                  </div>
                </div>
              </div>
            </div>
            <!-- 新增日期選擇器 -->
            <div class="datepicker-group" v-if="viewdetail.need_booking">
              <div class="datepicker-group-title">
                <span>{{$langt('請選擇日期')}}({{$langt('當地時間')}})</span>
              </div>
              <div class="datepicker-main">
                <div class="datepicker-wrapper">
                  <DatePicker 
                  v-model="date" 
                  :placeholder="$langt('請選擇日期')"
                  :append-to-body="true"  
                  :lang="langDatePicker" 
                  :disabled-date="disabledDate"/>
                </div>
                <div  v-if="filteredTimes.length > 0">
                  <select 
                  class="time-select" 
                  v-model="selectedTime" 
                  :disabled="!date || filteredTimes.length === 0">
                    <option value="" disabled selected hidden>{{$langt('請選擇時間')}}</option>
                    <option v-for="time in filteredTimes" :key="time" :value="time">
                      {{ time }}
                    </option>
                  </select>
                </div>
              </div>

            </div>
            <!-- -------- -->
            <div class="price-group">
              <div class="price-group-title">
                <span>{{ $langt('數量與價格') }}</span>
              </div>
              <div class="price-items a">
                <span>{{ $langt('單價') }}</span>
                <em>
                  <template v-if="pointSalePoint !== '-'">
                    <span class="point">{{ pointSalePoint }}</span>{{ $langt('點') }}
                  </template>
                  ＋{{ detail.currency_code | currencyTitle }}{{ pointSalePrice | priceFormat(detail.currency_code) }}
                </em>
              </div>
              <div class="price-items">
                <span>{{ $langt('數量') }}</span>
                <em>
                  <div class="number-input">
                    <button
                      :class="{ 'disabled-btn': isQtyDisabled }"
                      @click="handleQtyClick('pointQty', '-')"
                    ></button>
                    <input
                      ref="pointQty"
                      v-model="itemQty"
                      v-validate="'required|integer|min:1|max:' + maxQty + '|min_value:' + minQty"
                      class="quantity"
                      :min="minQty"
                      :max="maxQty"
                      :step="multiple"
                      name="pointQty"
                      type="number"
                      :data-vv-as="$langt('數量')"
                      @change="checkQty()"
                      @blur="checkQty()"
                    >
                    <button
                      class="plus"
                      :class="{ 'disabled-btn': isQtyDisabled }"
                      @click="handleQtyClick('pointQty', '+')"
                    ></button>
                  </div>
                </em>
              </div>
              <div v-if="errors.has('pointQty')" class="price-items">
                <span />
                <small class="help-block">{{ qtyMsg(minQty, maxQty) }}</small>
              </div>
              <div v-if="multiple > 1" class="price-items">
                <span />
                <small style="font-size: 10px;">{{ qtyMultipleMsg(multiple) }}</small>
              </div>
              <div class="price-items">
                <span>{{ $langt('訂單金額') }}</span>
                <em>
                  <small><span v-if="pointwarning" class="pointwarning">{{ $langt('點數不足') }}</span></small>
                  <template v-if="pointTotalPoint !== '-'">
                    <big>{{ pointTotalPoint }}</big>{{ $langt('點') }}
                  </template>
                  ＋{{ currencyCode | currencyTitle }}<big>{{ pointTotalPrice | priceFormat(currencyCode) }}</big>
                </em>
              </div>
            </div>
            <div class="btn-group-bottom">
              <button class="btn btn-reset" type="reset" @click="resetItem()">
                {{ $langt('清除重寫') }}
              </button>

              <button class="btn btn-next" type="button" @click="doPayment()">
                {{ $langt('下一步') }}
              </button>
            </div>
          </div>
        </template>
      </BottomSheet>
    </div>
    <QuickIcon />
  </div>
</template>

<script>
import Vue from 'vue'
import VueBottomSheet from '@webzlodimir/vue-bottom-sheet'
import HeaderInter from '@/components/HeaderInter'
import ProductSilder from '@/components/ProductSilder'
import BottomSheet from '@/components/BottomSheet'
import { getItem } from '@/api/shop'
import { showNotice, getStoreCode, getTitle } from '@/utils/tool'
import { pointcheck } from '@/utils/user'
import scrollSpy from 'vue2-scrollspy'
import FixedHeader from 'vue-fixed-header'
import QuickIcon from '@/components/QuickIcon'
import { gtmViewItem, gtmAddToCart } from '@/utils/gtmtool'
Vue.use(scrollSpy)

import DatePicker from 'vue2-datepicker' //日曆
import 'vue2-datepicker/index.css'

export default {
  name: 'ProductDetail',
  components: {
    HeaderInter,
    ProductSilder,
    VueBottomSheet,
    FixedHeader,
    QuickIcon,
    BottomSheet,
    DatePicker
  },
  data() {
    return {
      pointwarning: false,
      viewdetail: false,
      detail: false,
      titles: [this.$langt('方案'), this.$langt('特色'), this.$langt('權益'), this.$langt('分店')],
      // section: 0,
      fixed: false,
      overlay: true,
      maxWidth: '640px',
      maxHeight: '80%',
      clickToClose: true,
      effect: 'fx-default',
      rounded: true,
      // 數量
      multiple: null,
      maxQty: null,
      minQty: null,
      // 程式用
      selectedPlan: 0,
      selectedTarget: null,
      itemQty: this.$store.getters.orderItem.plans[0].prices[0].qty,
      randomBanner: null,
      //日曆
      date: null,
      selectedTime: '',
      langDatePicker: null
    }
  },
  computed: {
    isQtyDisabled() {
      if (!this.viewdetail || !this.viewdetail.plans) return false

      if (this.viewdetail.need_booking) {
        if (!this.date) return true

        const quotes = this.viewdetail.plans[this.selectedPlan].prices[0].quotes || []
        if (quotes.some(q => q.time) && !this.selectedTime) {
          return true
        }
      }
      return false
    },
    images: function() {
      if (this.detail.images.length > 0) {
        return [this.detail.cover_image, ...this.detail.images]
      } else {
        return [this.detail.cover_image]
      }
    },
    hasPoint: function() {
      return this.detail.has_points
    },
    cateName: function() {
      return this.detail.category_name
    },
    countryName: function() {
      return this.detail.areas[0] !== undefined ? this.detail.areas[0].name : ''
    },
    areaName: function() {
      return this.detail.areas[1] !== undefined ? this.detail.areas[1].name : ''
    },
    priceInclude: function() {
      return this.viewdetail.plans[this.selectedPlan].inclusion
    },
    priceExclude: function() {
      return this.viewdetail.plans[this.selectedPlan].exclusion
    },
    useGuide: function() {
      return this.viewdetail.plans[this.selectedPlan].guide
    },
    notice: function() {
      return this.viewdetail.plans[this.selectedPlan].notice
    },
    planDesc: function() {
      return this.viewdetail.plans[this.selectedPlan].description
    },
    planExpire: function() {
      if (!this.viewdetail.plans[this.selectedPlan].prices.length) return ''
      return this.viewdetail.plans[this.selectedPlan].prices[0].usedate_remark
    },
    creditSalePrice: function() {
      return this.selectedPrice().sale_price
        ? this.selectedPrice().sale_price
        : 0
    },
    creditTotalPrice: function() {
      return this.selectedPrice().sale_price
        ? this.selectedPrice().sale_price * this.selectedPrice().qty
        : 0
    },
    pointSalePoint: function() {
      return this.selectedPrice().point ? this.selectedPrice().point : '-'
    },
    pointSalePrice: function() {
      return this.selectedPrice().sale_price
        ? this.selectedPrice().sale_price
        : 0
    },
    // 總點數
    pointTotalPoint: function() {
      return this.selectedPrice().point
        ? this.selectedPrice().point * this.selectedPrice().qty
        : '-'
    },
    // 總價
    pointTotalPrice: function() {
      return this.selectedPrice().sale_price
        ? this.selectedPrice().sale_price * this.selectedPrice().qty
        : 0
    },
    // 
    selectedPrice() {
      return function(type, planInfo, priceInfo, pointInfo) {
        const selected = this.$store.getters.orderItem.plans[0].prices[0]
        return selected
      }
    },
    // 點數
    cashPointPay() {
      return getStoreCode() === 'happygo' ? this.$langt('HAPPYGO 點數優惠') : this.$langt('點數折抵')
    },
    currencyCode() {
      return this.$store.getters.currencyCode
    },
    // 去重複的日期
    availableDates() {
      let quotes = this.viewdetail.plans[this.selectedPlan].prices[0].quotes
      const dates = quotes.map(quote => quote.date)
      return [...new Set(dates)] // 去重複時間
    },
    filteredTimes() {
      if (!this.date || !this.viewdetail) return []

      const selectedDateStr = this.formatDate(this.date) //把Date轉YYYY-MM-DD字串

      //取出quotes陣列
      let quotes = this.viewdetail.plans[this.selectedPlan].prices[0].quotes

      //過濾出符合日期的quotes，並只取time字段
      const times = quotes
        .filter(q => q.date === selectedDateStr && q.time) //過濾null
        .map(q => q.time)
      return [...new Set(times)]//去重複時間（如果有）
    },
    // 語系
    langPath() {
      return this.$store.getters.langPath
    }
  },
  watch: {
    itemQty: function(val) {
      const item = this.$store.getters.orderItem
      item.plans[0].prices[0].qty = val
      const pcheck = pointcheck(
        parseInt(item.plans[0].prices[0].qty) *
          parseInt(item.plans[0].prices[0].point)
      )
      if (pcheck.needcheck && !pcheck.enough) {
        this.pointwarning = true
      } else {
        this.pointwarning = false
      }
      this.$store.commit('SET_ITEM', item)
    },
    date(newVal) {
      this.updateStock()
      const item = this.$store.getters.orderItem
      item.plans[0].prices[0].date = this.formatDate(newVal)
      this.$store.commit('SET_ITEM', item)
    },
    selectedTime(newVal) {
      this.updateStock()
      const item = this.$store.getters.orderItem
      item.plans[0].prices[0].selectedTime = newVal
      this.$store.commit('SET_ITEM', item)
    },
    langPath: {
      immediate: true,
      handler(newLang) {
        this.loadLocale(newLang || 'zh-tw')
      }
    }
  },
  created() {
    getItem(this.$route.params.id).then(response => {
      // 商品頁 Title
      if (response.data.data.length === 0) {
        const self = this
        getTitle()
        showNotice(this.$langt('查無商品資訊'), function() {
          self.$router.push('/product')
        })
      } else {
        getTitle(response.data.data.name)
        if (this.$route.params.cate) {
          response.data.data.category_id = this.$route.params.cate
        }
        this.detail = response.data.data
        this.viewdetail = this.initviewdataformat(response.data.data)
        // 若沒有店家資訊, 移除分頁的那個選項
        if (
          this.viewdetail.plans.length &&
          !this.viewdetail.plans[this.selectedPlan].branches.length
        ) {
          this.titles.splice(3, 1)
        }
        if (this.detail.item_id !== this.$store.getters.orderItem.item_id) {
          // 購物車跟本頁商品不符
          this.resetItem()
        }

        // GTM電子商務 view_item //
        try {
          const currency = this.viewdetail.currency_code
          const value = this.viewdetail.min_price
          const items = []
          this.viewdetail.plans.forEach(plan => {
            plan.prices.forEach(price => {
              items.push({
                item_id: price.price_id,
                item_name: this.getName(plan, price)
              })
            })
          })
          gtmViewItem(items, currency, value)
        } catch (error) {
          console.log(error)
        }
      }
    })
  },
  methods: {
    // Message
    qtyMsg(min, max) {
      return this.$langt('數量需大於{min}並小於{max}間的整數', { min, max })
    },
    qtyMultipleMsg(multiple){
      return this.$langt('購買數量需為{multiple}的倍數', { multiple })
    },
    initviewdataformat(data) {
      const finalarray = JSON.parse(JSON.stringify(data))
      finalarray.plans = []
      data.plans.forEach(element => {
        if (element.prices.length) {
          element.prices.forEach(e1 => {
            // 有票卷種類 篩選出純金的方案
            const _tmp = JSON.parse(JSON.stringify(element))
            const _tmp_prices = JSON.parse(JSON.stringify(e1))
            _tmp_prices.points = []
            _tmp.prices = []
            _tmp.prices.push(_tmp_prices)
            finalarray.plans.push(_tmp)
            // 假設有點數且有庫存
            if (e1.points.length && e1.stock !== 0) {
              // 篩選出不同種類的點加金方案
              e1.points.forEach((e, i, arr) => {
                const tmp_p = JSON.parse(JSON.stringify(_tmp))
                tmp_p.prices[0].points = []
                tmp_p.prices[0].points.push(e1.points[i])
                finalarray.plans.push(tmp_p)
              })
            }
          })
        }
      })
      return finalarray
    },
    getRandomBanner() {
      if (!this.randomBanner) {
        const banners = this.$store.getters.banner
        if (banners['ad_item_detail']) {
          if (banners['ad_item_detail']['content'].length === 0) {
            this.randomBanner = null
          } else {
            this.randomBanner =
              banners['ad_item_detail']['content'][
                Math.floor(
                  Math.random() * banners['ad_item_detail']['content'].length
                )
              ]
          }
        }
      }
      return this.randomBanner
    },
    changePlan(index) {
      this.selectedPlan = index
    },
    isSelectedPrices(target) {
      const res = []
      this.detail.plans.map(plan => {
        plan.prices.map(price => {
          if (parseInt(price.stock) > 0) {
            if (target === 'all') {
              res.push({
                plan: plan,
                price: price,
                point: null
              })
              if (price.points.length) {
                price.points.forEach(point => {
                  res.push({
                    plan: plan,
                    price: price,
                    point: point
                  })
                })
              }
            } else if (target === 'point') {
              price.points.map(point => {
                res.push({
                  plan: plan,
                  price: price,
                  point: point
                })
              })
            } else {
              res.push({
                plan: plan,
                price: price,
                point: null
              })
            }
          }
        })
      })
      return res.length === 1 ? res : false
    },
    open(target) {
      if (
        this.$store.getters.orderItem.plans[0].prices[0].point_id &&
        target !== 'point'
      ) {
        this.resetItem()
      } else if (
        !this.$store.getters.orderItem.plans[0].prices[0].point_id &&
        target !== 'credit'
      ) {
        this.resetItem()
      }
      const res = this.isSelectedPrices(target)
      if (res !== false) {
        this.setItem(res[0].plan, res[0].price, res[0].point)
      }
      // 選擇付款跟方案清單的相同選項 click對應的選項 2022/1/14
      if (target === 'all') {
        this.$refs.proditems[this.selectedPlan].click()
      }
      this.selectedTarget = target
      this.$refs[target].open()
    },
    close(target) {
      this.$refs[target].close()
    },
    handleQtyClick(ref, action) {
      if (this.isQtyDisabled) {
        showNotice(this.$langt('請選擇日期和時間'))
        return
      }
      switch (action) {
        case '+':
          this.$refs[ref].stepUp()
          break
        case '-':
          this.$refs[ref].stepDown()
          break
      }
      this.itemQty = this.$refs[ref].value
      this.checkQty()
    },
    checkQty() {
      if (!this.$store.getters.orderItem.item_id) {
        if(this.minQty > this.itemQty){
          return showNotice(this.$langt('請正確選擇方案、數量'))
        }
      }
      if (this.maxQty < this.itemQty) {
        const self = this
        showNotice(this.$langt('此項目最大數量') + ' ' + this.maxQty, function() {
          self.itemQty = self.maxQty
        })
      }

      const stepQty = parseInt(this.itemQty, 10) 
      const step = parseInt(this.multiple, 10)
      if (step && stepQty % step !== 0) {
        const remainder = stepQty % step
        this.itemQty = stepQty - remainder
      }
    },
    planClass(plan, index) {
      if (plan.prices[0].stock < 1) {
        return 'soldout'
      } else {
        if (this.selectedPlan === index) return 'active'
        else return ''
      }
    },
    planHasStock(plan) {
      return plan.prices[0].stock >= 1
    },
    doPayment() {
      if (this.viewdetail.need_booking === true) {
        if (!this.date) {
          showNotice(this.$langt('請選擇日期'))
          return
        }
        if (this.filteredTimes.length > 0 && !this.selectedTime) {
          showNotice(this.$langt('請選擇時間'))
          return
        }
      }
      if (this.$store.getters.orderItem.plans[0].prices[0].point) {
        const pcheck = pointcheck(
          parseInt(this.$store.getters.orderItem.plans[0].prices[0].qty) *
          parseInt(this.$store.getters.orderItem.plans[0].prices[0].point)
        )
        if (pcheck.needcheck && !pcheck.enough) {
          this.pointwarning = true
          showNotice(this.$langt('點數不足, 請確認你的點數!!'))
          return false
        }
      }
      if (!this.$store.getters.orderItem.item_id) {
        showNotice(this.$langt('請正確選擇方案、數量'))
      } else {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            // GTM電子商務 add_to_cart //
            try {
              const currency = this.viewdetail.currency_code
              const value = this.$store.getters.orderItem.plans[0].prices[0].sale_price * this.$store.getters.orderItem.plans[0].prices[0].qty
              const price_id = this.$store.getters.orderItem.plans[0].prices[0].price_id

              const { plan, price } = this.searchByPriceId(price_id)
              const items = [{
                item_id: price_id,
                item_name: this.getName(plan, price)
              }]
              gtmAddToCart(items, currency, value)
            } catch (error) {
              console.log(error)
            }

            this.close(this.selectedTarget)
            this.$router.push('/order/init')
          }
        })
      }
    },
    resetItem() {
      this.$store.commit('SET_DEFAULT_ITEM')
      this.itemQty = 1
      this.pointwarning = false
      this.date = ''
      this.selectedTime = ''
    },
    setItem(planInfo, priceInfo, pointInfo) {
      this.itemQty = priceInfo.quantity_min  // 初始數量
      this.minQty = priceInfo.quantity_min  // 最小值
      this.maxQty = priceInfo.quantity_max   // 最大值
      this.multiple = priceInfo.order_multiple  // 倍數
      let salePrice = priceInfo.sale_price // 單價

      // 點數
      let pointId = null
      let point = null
      if (pointInfo && pointInfo !== undefined) {
        pointId = pointInfo.point_id
        point = pointInfo.point
        salePrice = pointInfo.sale_price
        const pcheck = pointcheck(pointInfo.point)
        if (pcheck.needcheck && !pcheck.enough) {
          this.pointwarning = true
        } else {
          this.pointwarning = false
        }
      } else {
        // 不是點數都不要紅字提示
        this.pointwarning = false
      }

      // 存入store
      this.$store.commit('SET_ITEM', {
        item_id: this.detail.item_id,
        plans: [
          {
            plan_id: planInfo.plan_id,
            prices: [
              {
                price_id: priceInfo.price_id,
                sale_price: salePrice,
                qty: this.itemQty,
                multiple: this.multiple,
                point: point,
                point_id: pointId,
                minQty: this.minQty,
                maxQty: this.maxQty,
                date:  this.formatDate(this.date),
                selectedTime: this.selectedTime


              }
            ]
          }
        ]
      })
    },
    gettrusttext(info) {
      const trusttext = this.viewdetail.plans[this.selectedPlan].trusttext
        ? this.viewdetail.plans[this.selectedPlan].trusttext
        : this.viewdetail.trusttext
      return trusttext
    },
    getPlanPriceName(plan) {
      const plan_name = plan.plan_name || ''
      let price = {}
      if (plan.prices && plan.prices[0]) {
        price = plan.prices[0]
      }
      const { price_type, price_name, price_description } = price
      let str = `${plan_name} - ${price_type}`

      // 避免 price_type 和 price_name 重複
      if (price_name && price_type !== price_name) {
        str += ` ${price_name}`
      }

      // 價格說明
      if (price_description) {
        str += ` ${price_description}`
      }
      return str
    },
    /**
     * 用 price_id 搜尋 plan, price
     * @return { plan, price } 。沒有找到回傳 { }
     */
    searchByPriceId(price_id) {
      for (let i = 0; i < this.viewdetail.plans.length; i++) {
        const plan = this.viewdetail.plans[i]
        for (let j = 0; j < plan.prices.length; j++) {
          const price = plan.prices[j]
          if (price_id === price.price_id) {
            return { plan, price }
          }
        }
      }
      return {}
    },
    // 從 plan, price 計算出商品完整名稱 //
    getName(plan, price) {
      if (plan && price) {
        let result = this.viewdetail.name + ' - ' + plan.plan_name + ' - ' + price.price_type
        if (price.price_name && price.price_type !== price.price_name) {
          // 避免 price_type 和 price_name 重複 //
          result += ' ' + price.price_name
        }
        return result
      }
      return ''
    },
    //轉換時間格式
    formatDate(date) {
      if (!date) return ''
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    //決定某個日期是否要被禁用
    disabledDate(date) {
      const dateString = this.formatDate(date)

      //今天 00:00
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      //條件1：不在可用日期列表中
      const notInAvailable = this.availableDates.indexOf(dateString) === -1

      //條件2：小於今天
      const isPast = date < today

      return notInAvailable || isPast
    },
    // 預定商品更新最大數庫存
    updateStock() {
      if (this.viewdetail.need_booking === true) {
        if (this.date) {
          const selectedDate = this.formatDate(this.date)
          const selectedTime = this.selectedTime
          const quotes = this.viewdetail.plans[this.selectedPlan].prices[0].quotes || []
          
          let match = null
          
          if (selectedTime) {
            // 情況1: 需要日期+時間的商品
            match = quotes.find(q => q.date === selectedDate && q.time === selectedTime)
          } else {
            // 情況2: 只需要日期的商品 (時間為 null)
            match = quotes.find(q => q.date === selectedDate && (q.time === null || q.time === undefined || q.time === ''))
          }

          if (match) {
            this.maxQty = parseInt(match.stock, 10)
          } else {
            // this.maxQty = 0
          }
        }
        

      }else {
        // 若不是預定商品，使用預設庫存
        this.maxQty = this.viewdetail.plans[this.selectedPlan].prices[0].stock
      }
    },
    // 日期語系
    async loadLocale(lang) {
      const langMap = {
        'en': 'en',
        'ja': 'ja',
        'ko': 'ko',
        'zh-Hans': 'zh-cn',
        'id': 'id',
        'default': 'zh-tw'
      }
    
      const langKey = langMap[lang] || langMap['default']

      try {
        const localeModule = await import('vue2-datepicker/locale/'+ langKey)
        this.langDatePicker = localeModule.default || localeModule
      } catch (err) {
        const localeModule = await import('vue2-datepicker/locale/zh-tw')
        this.langDatePicker = localeModule.default || localeModule
      }
    }
  },
  mounted() {
    this.loadLocale(this.langPath)
  }
  
}
</script>

<style lang="scss">
@import 'assets/scss/common.scss';
.product-kv {
  margin-top: 44px;
}
.originprice {
  text-decoration: line-through;
  color: rgba($sec-color, $alpha: 0.4);
}
.originprice-sub {
  font-weight: normal !important;
  font-size: 0.8rem;
}
.saleprice-sub {
  color: rgba($sec-color, $alpha: 0.8);
  font-weight: normal !important;
  font-size: 0.8rem;
}
.theme {
  display: flex;
  justify-content: space-between;
  .theme-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.5rem;
    .theme-name {
      background: rgba($eating_item, $alpha: 0.85);
      color: rgba($white_color, $alpha: 0.85);
      border-radius: 50px;
      padding: 2px 10px;
      margin-right: 6px;
    }
    p {
      font-size: 1rem;
      margin: 0px;
      padding: 0;
    }
  }
}


.product-content {
  margin: 0;
  padding: 15px;
  position: relative;
  border-radius: 5px;
  z-index: 3;
  .name {
    font-size: 1.25rem;
    font-weight: bolder;
    margin: 0 0 0.5rem;
    padding: 0;
    span {
      color: $main-color;
      margin-right: 15px;
    }
  }
  .price {
    font-size: 1rem;
    margin: 0;
    padding: 0;
    color: $price-color;
    big {
      font-weight: bolder !important;
    }
  }
  .price-sub {
    color: rgba($font-color, $alpha: 0.8);
    font-weight: normal !important;
    font-size: 0.8rem;
  }

  .saleoff {
    margin: 0;
    text-align: right;
    font-size: 1.25rem;
    color: $price-color;
  }
}
// ProductTab
.sidebar {
  position: relative;
  z-index: 100;
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}

.menu {
  display: flex;
  flex-direction: row;
}
.menu-item {
  flex: 1 1 auto;
  text-align: center;
  background: $white-color;
  border-bottom: 1px solid rgba($sec-color, $alpha: 0.2);
  box-shadow: 0px 10px 10px 0px rgba($main-color, $alpha: 0.1);
}

.menu-item a {
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: block;
  padding: 10px 0;
}
.customActive {
  color: #fff;
  transition: all 0.5s;
  background: $main-color;
  border-radius: 0;
}

.promote-box img {
  border-radius: 4px;
}

.current-section {
  padding-top: 100px;
}
.main {
  padding-bottom: 7rem;
  p {
    margin: 0 0 0.5rem;
    padding: 0;
  }
  dl {
    padding-bottom: 1rem;
  }
  dt {
    color: $main-color;
    font-size: 1.15rem;
    margin-bottom: 0.35rem;
  }
  dd {
    font-size: 1rem;
    line-height: 1.85rem;
    margin: 0;
    padding: 0;
  }
  dd span {
    color: $sec-color;
  }
  ol,
  ul {
    margin: 0;
    padding: 0;
  }
  li {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    font-size: 1rem;
    line-height: 1.85rem;
    .price {
      color: $price-color;
      font-weight: bolder !important;
    }
  }
  .menu-list {
    li {
      background: $assist-color;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin: 0 0 0.65rem;
      padding: 0.85rem;
      line-height: 1rem;
      border-radius: 4px;
      .name {
        span {
          vertical-align: middle;
        }
        .refundtext {
          display: inline;
          line-height: 1;
          background-color: $price-color;
          color: white;
          font-weight: 700;
          border-radius: 4px;
          font-size: 12px;
          padding: 3px 8px;
          white-space: nowrap;
        }
      }
      .price {
        color: $price-color;
        line-height: 1rem;
        margin: 0;
        font-weight: bolder !important;
        display: flex;
        justify-content: space-between;
        em {
          font-style: normal;
        }
      }
    }
    li.soldout {
      color: rgba($black-color, $alpha: 0.35);
      .price span {
        color: rgba($black-color, $alpha: 0.35);
      }
    }
  }
}

.menu.vue-fixed-header--isFixed {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: 100vw;
}
@media screen and (min-width: 640px) {
  .menu.vue-fixed-header--isFixed {
    margin: auto;
    max-width: 640px;
  }
}

@media screen and (min-width: 768px) {
  .menu.vue-fixed-header--isFixed {
    max-width: 768px;
  }
}

@media screen and (max-width: 768px) {
  .theme {
    display: block;
    .theme-group {
      margin: 0;
    }
  }
}

//PaymentBtn
.sheet-content {
  height: 100%;
  // overflow: scroll;
  padding: 20px 10px;
  margin: 0 15px;
  .title {
    text-align: center;
    font-size: 1.15rem;
    font-weight: bolder;
    color: rgba($main-color, $alpha: 1);
    // 拿掉不要線條改關閉按鈕
    // background: -webkit-gradient(
    //   linear,
    //   0 0,
    //   0 100%,
    //   color-stop(0.5, #000),
    //   color-stop(0.5, transparent),
    //   to(transparent)
    // );
    // background-repeat: repeat-x;
    // background-position: center center;
    // -webkit-background-size: 2px;
    display: block;
    margin: 0 auto 5px;
    span {
      padding: 0 35px;
      background-color: $white-color;
    }
  }
}

@media screen and (min-width: 768px) {
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm),
    screen and(-webkit-min-device-pixel-ratio:0) {
    .sheet-content {
      margin: 0 auto;
      height: 55vh;
      overflow: scroll;
      padding: 10px 0px 10px 30px;
    }
  }
}

.prod-group,
.price-group,
.datepicker-group{
  margin-bottom: 1.5rem;
  .prod-group-title,
  .price-group-title,
  .datepicker-group-title{
    border-left: 5px solid $main-color;
    margin-bottom: 1rem;
    span {
      padding-left: 5px;
    }
  }
}
.prod-items {
  border: 1px solid $main-color;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 15px;
  margin: 0 0 5px;
  color: $sec-color;
  span,
  em {
    color: $font-color;
    font-size: 1rem;
    line-height: 1.15rem;
  }
  em {
    font-style: normal;
    text-align: right;
    .point {
      color: rgba($font-color, $alpha: 1);
      padding: 0 2px;
    }
  }
}

// .prod-items:hover,
// .prod-items:focus,
// .prod-items:active,
.prod-items.active {
  background: $main-color;
  color: $white-color;
  span,
  em {
    color: $white-color;
  }
}

.price-items {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  margin: 0px;
  color: rgba($font-color, $alpha: 1);
  line-height: 1.15rem;
  span {
    color: $main-color;
  }
  em {
    font-style: normal;
    .pointwarning {
      font-weight: bold;
      color: $warning-color;
      margin-right: 0.5rem;
    }
    .point {
      font-weight: bolder;
      color: rgba($font-color, $alpha: 1);
      padding: 0 3px;
    }
    big {
      color: $notice-color;
      font-weight: bolder;
      font-size: 1.5rem;
      font-family: 'Roboto', sans-serif;
      vertical-align: middle;
      top: -2px;
      position: relative;
    }
  }

  input[type='number'] {
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  .number-input {
    border: 1px solid $main-color;
    display: inline-flex;
    .quantity{
      width: 5rem;
    }
  }

  .number-input,
  .number-input * {
    box-sizing: border-box;
  }

  .number-input button {
    outline: none;
    -webkit-appearance: none;
    background-color: transparent;
    border: none;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
    margin: 0;
    position: relative;
  }

  .number-input button:before,
  .number-input button:after {
    display: inline-block;
    position: absolute;
    content: '';
    width: 0.7rem;
    height: 2px;
    background-color: $sec-color;
    transform: translate(-50%, -50%);
  }
  .number-input button.plus:after {
    transform: translate(-50%, -50%) rotate(90deg);
  }

  .number-input input[type='number'] {
    font-family: sans-serif;
    max-width: 10rem;
    padding: 0.8rem;
    border: solid $main-color;
    border-width: 0 2px;
    font-size: 1rem;
    height: 2.5rem;
    font-weight: bold;
    text-align: center;
    border-radius: 0 !important;
  }
}

.price-items:nth-child(2) {
  margin-bottom: 3px;
}

.sheet-content.credit {
  .title {
    color: rgba($notice-color, $alpha: 1);
  }
  .prod-group,
  .price-group{
    .prod-group-title,
    .price-group-title{
      border-left: 5px solid $notice-color;
    }
  }
  .prod-items {
    border: 1px solid $notice-color;
    span,
    em {
      color: $font-color;
    }
  }
  .prod-items:hover,
  .prod-items:focus,
  .prod-items:active,
  .prod-items.active {
    background: $notice-color;
    span,
    em {
      color: rgba($white-color, $alpha: 1);
    }
  }

  .price-items {
    span {
      color: $font-color;
    }
    .number-input {
      border: 1px solid $notice-color;
    }
    .number-input button:before,
    .number-input button:after {
      background-color: $sec-color;
    }
    .number-input input[type='number'] {
      border: solid $notice-color;
      border-width: 0 2px;
    }
  }
}

// 日期選擇
.mx-datepicker-popup {
  z-index: 999999 ; /* 高於 BottomSheet 即可 */
}
.datepicker-main{
  display: flex;
  .datepicker-wrapper{
    .mx-input-wrapper{
      max-width: 200px;     /* 設定最大寬度，避免太寬 */
      min-width: 150px;     /* 設定最小寬度，避免太窄 */
    }
  }
  .time-select{
    border: 1px solid #ccc;
    border-radius: 4px;
    color: #555;
    line-height: 1.4;
    font-size: 14px;
    height: 34px;
    max-width: 200px;     /* 設定最大寬度，避免太寬 */
    min-width: 150px;     /* 設定最小寬度，避免太窄 */
    padding: 6px 8px;
    overflow-y: auto  /* 加滾輪 */ !important;
      option{
        color: #555;
      }
  }
}

</style>
